import { useMutation, useQueryClient } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

type UseDenyKESMutationProps = {
    onSuccess?: () => void
    onError?: (error: unknown) => void
}

type DenyKESVariables = {
    id: string
}

export const useDenyKESMutation = ({ onSuccess, onError }: UseDenyKESMutationProps = {}) => {
    const { getTokenSilently, isAuthenticated } = useAuth0()
    const queryClient = useQueryClient()

    const denyKES = async ({ id }: DenyKESVariables) => {
        if (!isAuthenticated) throw new Error('User must be authenticated to deny a KES')

        const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
        if (!token) throw new Error('Failed to get authentication token')

        const response = await callAPI(endpoints.deleteKES.url + id, endpoints.deleteKES.method, token)

        if (!response.success) throw new Error(response.error || 'Failed to deny KES')

        return response
    }

    return useMutation(denyKES, {
        onSuccess: () => {
            queryClient.invalidateQueries(['draftKES'])
            onSuccess?.()
        },
        onError: (error) => {
            console.error('Error denying KES:', error)
            onError?.(error)
        },
    })
}
